import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { ProjectLink } from "../../components/ProjectLink";
import { hasAnyGrant } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import type { PurchaseRequisition } from "../../api-models";

export default function PRsListPage() {
  const { user } = useUser();
  const navigate = useNavigate();
  const canWrite = hasAnyGrant(user, "PR.Write");

  return (
    <ListPage<PurchaseRequisition>
      title="Purchase Requisitions"
      endpoint="/prs"
      searchPlaceholder="Search doc no or notes..."
      linkTo={(r) => `/procurement/prs/${r.id}`}
      actions={
        canWrite && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/procurement/prs/new")}>
            New requisition
          </Button>
        )
      }
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Project", render: (_, r) => <ProjectLink project={r.project} fallback="-" /> },
        { title: "Status", dataIndex: "status", sorter: true, render: (v) => <DocumentStatusTag status={v} /> },
      ]}
    />
  );
}
